module.exports = __webpack_public_path__ + "static/media/ic_book.5768ccf2.png";